import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'real-estate-developments-documents',
  storeModule.createStoreModule('real-estate-developments-documents')
)
